import React from "react"
import BookingButton from "../../BookingButton/BookingButton"

class BookingButtonBuilderWorkspace extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="booking-button-builder-workspace">
				<BookingButton {...this.props} position_override="absolute" />
			</div>
		);
	}
}

export default BookingButtonBuilderWorkspace